import { useContext, useMemo } from 'react';
import { MedicalCommitteesContext } from 'Context/MedicalCommitteesContext';
import {
  IMeetingDetails,
  ICommitteeLocation,
} from 'Interfaces/MedicalCommittees';

export const useCommitteeLocation = (
  meeting?: IMeetingDetails,
): ICommitteeLocation | undefined => {
  const { stateContent } = useContext(MedicalCommitteesContext);

  const committeeLocation = useMemo(() => {
    if (!meeting?.locationCode) {
      return undefined;
    }
    return stateContent?.committeeLocations?.find(
      (location) => location.committeeLocationId === meeting.locationCode,
    );
  }, [stateContent?.committeeLocations, meeting?.locationCode]);

  return committeeLocation;
};
